import { forwardRef, useRef } from "react";

import { Core } from "..";
import * as S from "./styles";

import { useTheme } from "styled-components";

// eslint-disable-next-line react/display-name
export const Date = forwardRef(
  ({ gridArea, margin, disabled, ...props }, ref) => {
    const inputRef = useRef(null);
    const theme = useTheme();

    return (
      <S.DateInputWrapper gridArea={gridArea} margin={margin} {...props}>
        <Core
          ref={(e) => {
            // O ref externo é opcional: uso CONTROLADO (value/onChange, fora
            // do react-hook-form) não passa ref — chamar ref(e) sem guarda
            // derrubava a tela em branco (pego pelo E2E de A13).
            if (typeof ref === "function") ref(e);
            else if (ref) ref.current = e;
            inputRef.current = e;
          }}
          disabled={disabled}
          {...props}
          prefix={{
            icon: {
              name: "Calendar",
              position: "left",
              size: "xs",
              color: theme.colors.neutral.white,
              onClick: () => {
                !disabled && inputRef.current.showPicker();
              },
            },
          }}
        />
      </S.DateInputWrapper>
    );
  },
);
